import styled from '@emotion/styled';
import React from 'react';

import {
  LeftNavMenu,
  LeftNavMenuItem,
} from '~/client/components/base/left-nav';

interface Props {
  className?: string;
}

const AccountImpl: React.FC<Props> = ({ className }) => {
  return (
    <LeftNavMenu className={className} name="account">
      <LeftNavMenuItem>Account 1</LeftNavMenuItem>
      <LeftNavMenuItem disabled>Delete Account</LeftNavMenuItem>
    </LeftNavMenu>
  );
};

const Account = styled(AccountImpl)``;

export default Account;
